import apiManager from "@/api/ApiManager";
import {
    SEND_OTP,
    VERIFY_OTP
} from "../actionsType.js";

// initial state
const state = {
};

// getters
const getters = {};

const actions = {
  [SEND_OTP](context, requestModal) {
    return new Promise((success, reject) => {
      apiManager.post("/api/OTPSendMail/SendOtp", requestModal)
        .then((response) => {
          success(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [VERIFY_OTP](context, requestModal) {
    return new Promise((success, reject) => {
      apiManager.post("/api/OTPSendMail/verifyOtp", requestModal)
        .then((response) => {
          success(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
export default {
  state,
  getters,
  actions,
  // mutations,
};
